export const getContrastingColor = (bgColor: string): string => {
  let color = bgColor;

  if (color.startsWith('#')) color = color.slice(1);

  if (color.length === 3) {
    color = color
      .split('')
      .map(c => c + c)
      .join('');
  }

  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  return luminance > 150 ? '#000000' : '#ffffff';
};
